import React, { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { VendorSoftwareSetupFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import {
  FinancialDocumentAssociationType,
  InvoiceForm,
} from 'modules/finance/components/Invoices/Detail/Content/Form/types'
import { FinanceSoftwareSelector } from 'modules/finance/components/selectors/FinanceSoftwareSelector'

interface SoftwareSelectorProps {
  form: FormikProps<InvoiceForm>
  readonly: boolean
  onClear: () => void
  selectedSoftwareObject: VendorSoftwareSetupFragment | undefined | null
}

const SoftwareSelector: React.FC<SoftwareSelectorProps> = ({
  form,
  readonly,
  onClear,
  selectedSoftwareObject,
}) => {
  const { navigation } = useNavigation()

  const selectedId =
    form.values.associations?.[0]?.resource?.type == FinancialDocumentAssociationType.SoftwareSetup
      ? form.values.associations?.[0]?.resource?.id
      : undefined

  const [currentValue, setCurrentValue] = useState<VendorSoftwareSetupFragment | null>(
    selectedSoftwareObject || null
  )

  const handleChange = (value: VendorSoftwareSetupFragment | null) => {
    if (value) {
      form.setFieldValue('associations', [
        {
          resource: { id: Number(value.id), type: 'softwaresetup' },
        },
      ])
    } else {
      onClear()
    }
    setCurrentValue(value)
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" gap="s16" alignItems="flexEnd">
      <FinanceSoftwareSelector value={currentValue} onChange={handleChange} disabled={readonly} />
      {selectedId && (
        <Box paddingBottom={'s6'}>
          <Button.Router
            aria-label={i18n.t('finance.invoices.detail.fields.router_label_software')}
            type="secondary"
            blankTarget
            to={navigation.software.applications.applicationId.fullPath({
              application_id: selectedId,
            })}
            iconName="arrow-right"
          />
        </Box>
      )}
    </Box>
  )
}

export default SoftwareSelector
